import * as mutations from "./mutation-types";
import { getState } from "@/storage/db";
import api from "@/api";
import { LOAD_FROM_CACHE } from "./mutation-types";

export const changeLocale = async (context, locale) => {
  await api.locale.change(locale);

  localStorage.setItem("locale", locale.split("_")[0]);
  window.location.reload();
};

export const initialize = async ({ commit, dispatch }) => {
  try {
    let state = await getState();
    commit(LOAD_FROM_CACHE, state || {});
  } catch (e) {
    console.error("failed to load state from cache", e);
  }

  return Promise.all([
    dispatch("menus/getMegaMenu"),
    dispatch("menus/getFooterMenu"),
    dispatch("cart/getCart"),
  ]);
};

export const refreshOnVisible = async ({ dispatch }) => {
  return Promise.all([
    dispatch("customers/getCustomer"),
    dispatch("menus/getMegaMenu"),
    dispatch("menus/getFooterMenu"),
    dispatch("cart/getCart"),
  ]);
};

export const getDeals = async ({ commit }) => {
  let res = await api.deal.all();
  commit(mutations.SET_DEALS, res.data);

  return res;
};

export const togglePrimaryChat = async ({ commit }) => {
  commit(mutations.LAYOUT_TOGGLE_PRIMARY_CHAT);
};

export const toggleSecondaryChat = async ({ commit }) => {
  commit(mutations.LAYOUT_TOGGLE_SECONDARY_CHAT);
};

export const hideSecondaryChat = async ({ commit }) => {
  commit(mutations.LAYOUT_TOGGLE_SECONDARY_CHAT);
};
